export const generateTimeOptions = () => {
  const times = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += 30) {
      const hour12 = ((h + 11) % 12) + 1;
      const meridiem = h < 12 ? 'AM' : 'PM';
      const minutes = m === 0 ? '00' : '30';
      times.push(`${hour12}:${minutes} ${meridiem}`);
    }
  }
  return times;
};
